import { getObjectValue } from "@mittwald/flow-lib/dist/object/getObjectValue";
export const getDesignTokenValue = (path, object) => {
    if (typeof path !== "string") {
        return;
    }
    const value = getObjectValue(path, object, {
        delimiter: "-",
        defaultValueObjectKey: "default",
    });
    if (typeof value === "string") {
        return value;
    }
    if (typeof value === "function") {
        return value();
    }
};
export default getDesignTokenValue;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0RGVzaWduVG9rZW5WYWx1ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9taXhpbnMvbGliL2dldERlc2lnblRva2VuVmFsdWUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLGNBQWMsRUFBRSxNQUFNLCtDQUErQyxDQUFDO0FBRy9FLE1BQU0sQ0FBQyxNQUFNLG1CQUFtQixHQUFHLENBQ2pDLElBQTBELEVBQzFELE1BQVMsRUFDVyxFQUFFO0lBQ3RCLElBQUksT0FBTyxJQUFJLEtBQUssUUFBUSxFQUFFLENBQUM7UUFDN0IsT0FBTztJQUNULENBQUM7SUFFRCxNQUFNLEtBQUssR0FBRyxjQUFjLENBQUMsSUFBSSxFQUFFLE1BQU0sRUFBRTtRQUN6QyxTQUFTLEVBQUUsR0FBRztRQUNkLHFCQUFxQixFQUFFLFNBQVM7S0FDakMsQ0FBQyxDQUFDO0lBRUgsSUFBSSxPQUFPLEtBQUssS0FBSyxRQUFRLEVBQUUsQ0FBQztRQUM5QixPQUFPLEtBQUssQ0FBQztJQUNmLENBQUM7SUFDRCxJQUFJLE9BQU8sS0FBSyxLQUFLLFVBQVUsRUFBRSxDQUFDO1FBQ2hDLE9BQU8sS0FBSyxFQUFFLENBQUM7SUFDakIsQ0FBQztBQUNILENBQUMsQ0FBQztBQUVGLGVBQWUsbUJBQW1CLENBQUMifQ==